import React, { useEffect } from "react";
import { useTimeSheetStore } from "../../config/stores";
import { first, groupBy, isEmpty, map, orderBy } from "lodash";
import TimeSheetDetails from "./MyTimeSheets/MangeMyTimeSheets/TimeSheetDetails";
import TimeSheetsTable from "./MyTimeSheets/MangeMyTimeSheets/TimeSheetsTable";
import dayjs from "dayjs";
import { Card, Collapse, Tabs, Tag } from "antd";
import AppButton from "../../components/common/AppButton";
import { AiOutlineReload } from "react-icons/ai";
const TimeSheets = () => {
  const timeSheetsStore = useTimeSheetStore();
  useEffect(() => {
    if (isEmpty(timeSheetsStore.timeSheets)) {
      timeSheetsStore.getTimeSheets();
    }
  }, []);

  // console.log(timeSheets);
  const timeSheetsGroupedByYear = orderBy(
    map(
      groupBy(timeSheetsStore.timeSheets?.data, "year"),
      (yearTimeSheets, year) => {
        const timeSheets = orderBy(
          map(
            groupBy(
              yearTimeSheets,
              (timeSheet) => `${timeSheet.month}-${timeSheet.year}`
            ),
            (records) => {
              const context = first(records);

              return {
                timeSheets: records,
                month: dayjs().month(Number(context.month) - 1).format("MMMM"),
                monthNo: context.month,
                year: context.year,
              };
            }
          ),
          ["year", "monthNo"],
          ["desc", "desc"]
        );

        return {
          year,
          timeSheets,
        };
      }
    ),
    ["year"],
    ["desc"]
  );

  // <TimeSheetsTable timeSheets={timeSheetsStore.timeSheets?.data} />
  return (
    <div className="container-fluid p-2">
      {timeSheetsStore.showTimeSheetDetails ? (
        <TimeSheetDetails />
      ) : (
        <Card
          title="TIME SHEETS"
          extra={
            <AppButton
              text="RELOAD"
              type="default"
              loadingText="LOADING..."
              loading={timeSheetsStore.gettingTimeSheets}
              iconBefore={<AiOutlineReload />}
              onClick={timeSheetsStore.getTimeSheets}
            />
          }
        >
          <Tabs
            type="card"
            items={map(timeSheetsGroupedByYear, (yearTimeSheets) => ({
              label: <span>{yearTimeSheets.year}</span>,
              key: yearTimeSheets.year,
              children: (
                <Collapse
                  items={map(yearTimeSheets.timeSheets, (timeSheet) => ({
                    label: (
                      <span className="text-uppercase fw-bold">
                        {timeSheet.month} -{" "}
                        <Tag color="green">{timeSheet.year}</Tag>
                      </span>
                    ),
                    key: ` ${timeSheet.month} - ${timeSheet.year}`,
                    children: (
                      <TimeSheetsTable timeSheets={timeSheet.timeSheets} />
                    ),
                  }))}
                />
              ),
            }))}
          />
        </Card>
      )}
    </div>
  );
};

export default TimeSheets;
